export default __webpack_public_path__ + "static/taras-02315fed1e7ddfdc96e3d92ee45fa455.png";